export const EditIcon = ({ className }) => {
  return (
    <svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M7.76693 2.14116C7.81215 2.24245 7.83567 2.35126 7.83612 2.46126C7.83726 2.57128 7.81532 2.68045 7.77159 2.78243C7.72785 2.88442 7.66319 2.97719 7.58135 3.05539L2.32776 7.6748C2.29262 7.70842 2.25081 7.73513 2.20474 7.75341C2.15867 7.7717 2.10925 7.78119 2.05931 7.78134L0.430649 8.04714C0.330084 8.04788 0.233361 8.01077 0.161759 7.94397C0.090157 7.87718 0.0495402 7.78618 0.0488444 7.69098L0.304758 6.00691C0.304152 5.91186 0.343395 5.82044 0.41388 5.75269L5.68106 1.20336C5.84858 1.04996 6.072 0.963435 6.30498 0.961732C6.53796 0.960029 6.76262 1.04328 6.93236 1.19421L7.57269 1.87115C7.65569 1.94808 7.72171 2.03986 7.76693 2.14116Z" />
      <path d="M7.8848 7.88801C7.95542 7.82017 7.9947 7.72859 7.99401 7.63339C7.99331 7.5382 7.95269 7.44719 7.88109 7.3804C7.80949 7.31361 7.71277 7.2765 7.6122 7.27723L3.87949 7.30451C3.77893 7.30525 3.68276 7.34377 3.61214 7.4116C3.54152 7.47943 3.50224 7.57102 3.50294 7.66622C3.50363 7.76141 3.54425 7.85241 3.61585 7.91921C3.68745 7.986 3.78418 8.02311 3.88474 8.02238L7.61745 7.9951C7.71801 7.99436 7.81418 7.95584 7.8848 7.88801Z" />
    </svg>
  );
};
export const EditIconDynamic = ({ className }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="16" height="17" rx="2.5" stroke="#999999" />
      <path
        d="M12.7669 6.14116C12.8122 6.24245 12.8357 6.35126 12.8361 6.46126C12.8373 6.57128 12.8153 6.68045 12.7716 6.78243C12.7279 6.88442 12.6632 6.97719 12.5813 7.05539L7.32776 11.6748C7.29262 11.7084 7.25081 11.7351 7.20474 11.7534C7.15867 11.7717 7.10925 11.7812 7.05931 11.7813L5.43065 12.0471C5.33008 12.0479 5.23336 12.0108 5.16176 11.944C5.09016 11.8772 5.04954 11.7862 5.04884 11.691L5.30476 10.0069C5.30415 9.91186 5.3434 9.82044 5.41388 9.75269L10.6811 5.20336C10.8486 5.04996 11.072 4.96343 11.305 4.96173C11.538 4.96003 11.7626 5.04328 11.9324 5.19421L12.5727 5.87115C12.6557 5.94808 12.7217 6.03986 12.7669 6.14116Z"
        className={className}
      />
      <path
        d="M12.8848 11.888C12.9554 11.8202 12.9947 11.7286 12.994 11.6334C12.9933 11.5382 12.9527 11.4472 12.8811 11.3804C12.8095 11.3136 12.7128 11.2765 12.6122 11.2772L8.87949 11.3045C8.77893 11.3052 8.68276 11.3438 8.61214 11.4116C8.54152 11.4794 8.50224 11.571 8.50294 11.6662C8.50363 11.7614 8.54425 11.8524 8.61585 11.9192C8.68745 11.986 8.78418 12.0231 8.88474 12.0224L12.6174 11.9951C12.718 11.9944 12.8142 11.9558 12.8848 11.888Z"
        className={className}
      />
    </svg>
  );
};

export const ArrowIcon = ({ className }) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 7L4 4L1 1" className={className} />
      <path d="M4 7L7 4L4 1" className={className} />
    </svg>
  );
};
